// AIDEV-NOTE: 서버 응답 이상(self-contradiction)을 외부 모니터링으로 흘려보내는 통로.
//
// 이 패키지는 Sentry 를 초기화하지 않는 앱(admin, share-report)에서도 로드되므로
// @sentry/vue 를 여기서 직접 import 하지 않는다. 정적 import 면 그 앱들의 번들에 SDK 가
// 통째로 실리고, 동적 import 로 바꿔도 청크가 생성돼 이상 발생 시 무의미하게 받아온다
// (실측: share-report 메인 번들에 brotli 기준 약 98KB 추가).
// 대신 Sentry 를 쓰는 앱이 시작 시 리포터를 주입한다 (apps/webview-inapp/src/main.ts).
// 주입이 없으면 호출부의 console.warn 까지만 남고 조용히 끝난다.

export interface AnomalyReport {
    /** 이상의 종류. Sentry 태그로 쓰여 이슈 그룹을 가른다. */
    kind: string;
    /** 중복 제거 단위. 월 단위 이상은 'YYYY-MM', 진입 시 1회성 이상은 'init'. */
    scope: string;
    extra: Record<string, unknown>;
}

export type AnomalyReporter = (message: string, report: AnomalyReport) => void;

let reporter: AnomalyReporter | null = null;

export const setAnomalyReporter = (fn: AnomalyReporter | null) => {
    reporter = fn;
};

export const sendAnomalyReport = (message: string, report: AnomalyReport) => {
    if (!reporter) return;

    try {
        reporter(message, report);
    } catch (error) {
        // 리포터가 죽어도 화면 로직에는 영향이 없어야 한다.
        console.warn('[trend-report] anomaly reporter 실패', error);
    }
};
